import React, { useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { LocaleContext, Textarea } from 'shared';
import { required as requiredValidator } from 'utils/formValidators';

export const Description = () => {
  const localeContext = useContext(LocaleContext);

  const required = requiredValidator(localeContext.formatMessage({ id: 'FORM.REQUIRED' }));

  return (
    <Field name="description" validate={required}>
      {({ input, meta }: FieldRenderProps<HTMLTextAreaElement>) => (
        <Textarea
          rows={5}
          resizeable={false}
          label={localeContext.formatMessage({ id: 'APPLICATION.FORM.APP-DESCRIPTION' })}
          input={input}
          meta={meta}
          className="application-form__description"
          maxLenght={400}
          charsCounter={true}
        />
      )}
    </Field>
  );
};
